export default {
  path: '/tms',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: '',
      name: 'tms',
      component: () => import('@/pages/tms/index.vue'),
      meta: {
        keepAlive: true,
        title: '',
      },
    },
  ],
};
